/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import Seccion_Home from "./Secciones/Seccion_Home";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Footer from "././Footer";
import Seccion_Detalle from "./Secciones/Seccion_Detalle";

const Pagina = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Router>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                    <Barra/>
                </Grid>

                <h1 style={{display: 'none'}}>Provedor de Cafe Colombiano</h1>
                <h2 style={{display: 'none'}}>Cafe exotico</h2>
                <h2 style={{display: 'none'}}>Cafe Honey</h2>
                <h2 style={{display: 'none'}}>Importar cafe colombiano</h2>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/"} element={<Seccion_Home/>}/>
                        <Route path={"/Detalle/:id"} element={<Seccion_Detalle/>}/>
                    </Routes>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Footer/>
                </Grid>


            </Router>

        </Grid>
    )

}
export default Pagina